import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["sx"];
import PropTypes from 'prop-types';
import * as React from 'react';
import MuiTab from '@mui/material/Tab';
import { extendSX } from '../helpers';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Demos:
 *
 * - [Tabs](https://ui-packages.isbuildingluma.com/ui-core/react-tabs/)
 *
 * API:
 *
 * - [Tab API](https://ui-packages.isbuildingluma.com/ui-core/api/tab/)
 * - inherits [MuiTab API](https://mui.com/material-ui/api/tab/)
 */
const Tab = /*#__PURE__*/React.forwardRef(function Tab(_ref, ref) {
  let {
      sx
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  // @ts-ignore MuiTab making problems bc of `children: null` type
  return /*#__PURE__*/_jsx(MuiTab, _extends({
    ref: ref,
    sx: extendSX(sx)
  }, rest));
});
process.env.NODE_ENV !== "production" ? Tab.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit "TabProps.ts" and run "yarn proptypes"
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export default Tab;